import { useEffect, useMemo, useRef, useState } from 'react';
import TimeZoneConverter from '../shared/timezone';
import { TextHighlighter } from '../shared/textBold';
import {
	useContractFilters,
	useFieldsFilters,
	useGlobalSearch,
	useInvoiceChildFilters,
	useInvoiceParentFilters,
	useSearchInvoices,
} from './hooks';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import {
	createSearchParams,
	useNavigate,
	useOutletContext,
	useSearchParams,
} from 'react-router-dom';
import LoaderFull from '../shared/loader-full-screen';
import { Autocomplete, TextField } from '@mui/material';
import { ContractDropdownOption } from './contractDropdown';
import dayjs from 'dayjs';
import DatePickerButton from './dateSelector';
import { filter } from 'rxjs';
import { setIn } from 'formik';
import { PAGE_SIZE_OPTIONS, encodeName, sortDropdownOptions } from '../utils';
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';

export const FilterInvoiceList = ({
	data,
	count,
	getpageSizeCall,
	setpageSizeCall,
}) => {
	const [Count, setCount] = useState(count);
	const [searchParams, setSearchParams] = useSearchParams();
	const [invData, setInvData] = useState(data);
	const [page, setpage] = useState(1);
	const inv_data_hook = useGlobalSearch();
	const navigate = useNavigate();
	const getfilterHook = useInvoiceParentFilters();
	const getChildFiltersHook = useInvoiceChildFilters();
	const getContractFiltersHook = useContractFilters();
	const searchInvoiceListHook = useSearchInvoices();
	const fieldsFilterHook = useFieldsFilters();
	const [selectedVendor, setSelectedVendor] = useState('');
	const [selectedCategory, setSelectedCategory] = useState('');
	const [selectedClient, setSelectedClient] = useState('');
	const [Filters, setFilters] = useState([]);
	const [childFilters, setChildFilters] = useState([]);
	const [contractFilters, setContractFilters] = useState([]);
	const [fields, setFields] = useState([]);
	const [pageSize, setPageSize] = useState(null);

	useEffect(() => {
		if (getfilterHook?.data) {
			setFilters(getfilterHook.data.data);
		}
	}, [getfilterHook?.data, getfilterHook?.isSuccess]);

	useEffect(() => {
		if (fieldsFilterHook?.data) {
			setFields(sortDropdownOptions(fieldsFilterHook.data.data));
		}
	}, [fieldsFilterHook?.data, fieldsFilterHook?.isSuccess]);

	function keywordSearch(page = 1) {

		if (
			searchParams.get('keyword')?.trim() === '' ||
			searchParams.get('keyword') === null
		) {
			setInvData([]);
			return;
		}

		setInvData([]);
		let bd = {
			keyword: searchParams.get('keyword'),
			invoice: true,
			invoice_limit: pageSize,
			invoice_page: page,
		};
		console.log(bd, 'bd');

		inv_data_hook.mutate(bd);
	}

	useEffect(() => {
		if (selectedCategory && selectedClient && selectedVendor) {
			return 
		}
		keywordSearch(page);
	}, [page]);

	useEffect(() => {
		if (pageSize) {
			if (selectedCategory && selectedClient && selectedVendor) {
				applySearch(1)
			}
			else if (page == 1) {
				keywordSearch(1);
			} else {
				setpage(1);
			}
			
		}
	}, [pageSize]);

	useEffect(() => {
		setInvData(data);
		setpage(1);
	}, [data]);

	useEffect(() => {
		if (inv_data_hook.isSuccess && inv_data_hook.data) {
			setInvData(inv_data_hook.data?.invoice);
		}
	}, [inv_data_hook.isSuccess, inv_data_hook.data]);

	function getUniqueClients(
		lst,
		selectedVendor = null,
		selectedCategory = null
	) {
		const uniqueClients = [];
		const seenClientIds = new Set();

		lst
			?.filter((item) => {
				// If no vendor or category selected, include all
				if (!selectedVendor && !selectedCategory) return true;
				// If both vendor and category selected, match both
				if (selectedVendor && selectedCategory) {
					return (
						item.vendor_id === selectedVendor?.vendor_id &&
						item.category_id === selectedCategory?.category_id
					);
				}
				// If only vendor selected
				if (selectedVendor) {
					return item.vendor_id === selectedVendor?.vendor_id;
				}
				// If only category selected
				if (selectedCategory) {
					return item.category_id === selectedCategory?.category_id;
				}
				return true;
			})
			?.forEach((item) => {
				if (!seenClientIds.has(item.client_id)) {
					seenClientIds.add(item.client_id);
					uniqueClients.push({
						client_id: item.client_id,
						client: item.client,
					});
				}
			});

		return sortDropdownOptions(uniqueClients, (o) => o.client);
	}

	function getUniqueVendors(
		lst,
		selectedClient = null,
		selectedCategory = null
	) {
		const uniqueVendors = [];
		const seenVendorIds = new Set();

		lst
			?.filter((item) => {
				// If no vendor or category selected, include all
				if (!selectedClient && !selectedCategory) return true;
				// If both vendor and category selected, match both
				if (selectedClient && selectedCategory) {
					return (
						item.client_id === selectedClient?.client_id &&
						item.category_id === selectedCategory?.category_id
					);
				}
				// If only vendor selected
				if (selectedVendor) {
					return item.vendor_id === selectedVendor?.vendor_id;
				}
				// If only category selected
				if (selectedClient) {
					return item.client_id === selectedClient?.client_id;
				}
				return true;
			})
			?.forEach((item) => {
				if (!seenVendorIds.has(item.vendor_id)) {
					seenVendorIds.add(item.vendor_id);
					uniqueVendors.push({
						vendor_id: item.vendor_id,
						vendor: item.vendor,
					});
				}
			});

		return sortDropdownOptions(uniqueVendors, (o) => o.vendor);
	}

	function getUniqueCategories(
		lst,
		selectedVendor = null,
		selectedClient = null
	) {
		const uniqueCategories = [];
		const seenCategoryIds = new Set();

		lst
			?.filter((item) => {
				// If no vendor or category selected, include all
				if (!selectedClient && !selectedVendor) return true;
				// If both vendor and category selected, match both
				if (selectedClient && selectedVendor) {
					return (
						item.client_id === selectedClient?.client_id &&
						item.vendor_id === selectedVendor?.vendor_id
					);
				}
				// If only vendor selected
				if (selectedVendor) {
					return item.vendor_id === selectedVendor?.vendor_id;
				}
				// If only category selected
				if (selectedClient) {
					return item.client_id === selectedClient?.client_id;
				}
				return true;
			})
			?.forEach((item) => {
				if (!seenCategoryIds.has(item.category_id)) {
					seenCategoryIds.add(item.category_id);
					uniqueCategories.push({
						category_id: item.category_id,
						category_name: item.category_name,
					});
				}
			});

		return sortDropdownOptions(uniqueCategories, (o) => o.category_name);
	}

	const uniqueClients = useMemo(
		() => getUniqueClients(Filters, selectedVendor, selectedCategory),
		[Filters, selectedClient, selectedVendor, selectedCategory]
	);
	const uniqueVendors = useMemo(
		() => getUniqueVendors(Filters, selectedClient, selectedCategory),
		[Filters, selectedClient, selectedVendor, selectedCategory]
	);
	const uniqueCategories = useMemo(
		() => getUniqueCategories(Filters, selectedVendor, selectedClient),
		[Filters, selectedClient, selectedVendor, selectedCategory]
	);

	const [selectedContract, setSelectedContract] = useState(null);
	const [selectedField, setSelectedField] = useState(null);
	const [selectedInvoice, setSelectedInvoice] = useState(null);
	const [selectedPublishedOn, setSelectedPublishedOn] = useState(new Set());
	const [selectedUploadedAt, setSelectedUploadedAt] = useState(new Set());
	const [selectedUploadedBy, setSelectedUploadedBy] = useState(null);
	const [selectedAnnotatedAt, setSelectedAnnotatedAt] = useState(new Set());
	const [selectedAnnotatedBy, setSelectedAnnotatedBy] = useState(null);
	const filterChangeDetected = useRef(false);

	function clearAllFilters() {
		setSelectedVendor('');
		setSelectedCategory('');
		setSelectedClient('');
		setSelectedContract(null);
		setSelectedField(null);
		setSelectedInvoice(null);
		setSelectedPublishedOn(new Set());
		setSelectedUploadedAt(new Set());
		setSelectedUploadedBy(null);
		setSelectedAnnotatedAt(new Set());
		setSelectedAnnotatedBy(null);
		setInvData([]);

		if (page !== 1) {
			setpage(1);
		} else {
			keywordSearch(1);
		}
	}

	function getUniqueValues(lst, key, filters, selectedContract) {
		const uniqueValues = [];
		const seenIds = new Set();

		lst
			.filter((itm) => itm[key])
			.filter((itm) => {
				return filters.every((filter) => {
					if (
						filter.key === 'published_on' ||
						filter.key === 'uploaded_at' ||
						filter.key === 'annotated_at'
					) {
						return (
							filter.value?.size == 0 ||
							[...filter.value]?.some((vl) =>
								dayjs(itm[filter.key])?.isSame(dayjs(vl), 'day')
							)
						);
					} else {
						if (!filter.value) {
							return true;
						}
						if (filter.key === 'invoice_name') {
							return itm[filter.key] === filter.value.invoice_name;
						} else if (
							filter.key === 'uploaded_by' ||
							filter.key === 'annotated_by'
						) {
							return itm[filter.key] === filter.value._id;
						}
					}
				});
			})
			.filter((itm) => {
				if (selectedContract) {
					try {
						const contractStartDate = new Date(selectedContract.start_date);
						const contractEndDate = new Date(selectedContract.end_date);
						const itemDate = new Date(itm['published_on']);
						return itemDate >= contractStartDate && itemDate <= contractEndDate;
					} catch (error) {
						return true;
					}
				}
				return true;
			})
			?.forEach((item) => {
				if (!seenIds.has(item[key])) {
					seenIds.add(item[key]);
					if (key === 'invoice_name') {
						uniqueValues.push({
							_id: item._id,
							invoice_name: item[key],
						});
					} else if (key === 'uploaded_by') {
						uniqueValues.push({
							_id: item.uploaded_by,
							uploaded_by: item['uploaded_by_name'],
						});
					} else if (key === 'annotated_by') {
						uniqueValues.push({
							_id: item.annotated_by,
							annotated_by: item['annotated_by_name'],
						});
					} else {
						uniqueValues.push(item[key]);
					}
				}
			});
		return sortDropdownOptions(uniqueValues, (item) => {
			if (item && typeof item === 'object') {
				return (
					item.invoice_name ??
					item.uploaded_by ??
					item.annotated_by ??
					''
				);
			}
			return item;
		});
	}

	const uniqueInvoices = useMemo(
		() =>
			getUniqueValues(
				childFilters,
				'invoice_name',
				[
					{ key: 'published_on', value: selectedPublishedOn },
					{ key: 'uploaded_at', value: selectedUploadedAt },
					{ key: 'uploaded_by', value: selectedUploadedBy },
					{ key: 'annotated_at', value: selectedAnnotatedAt },
					{ key: 'annotated_by', value: selectedAnnotatedBy },
				],
				selectedContract
			),
		[
			childFilters,
			selectedInvoice,
			selectedPublishedOn,
			selectedUploadedAt,
			selectedUploadedBy,
			selectedAnnotatedAt,
			selectedAnnotatedBy,
			selectedContract,
		]
	);

	const uniquePublishedOn = useMemo(
		() =>
			getUniqueValues(
				childFilters,
				'published_on',
				[
					{ key: 'invoice_name', value: selectedInvoice },
					{ key: 'uploaded_at', value: selectedUploadedAt },
					{ key: 'uploaded_by', value: selectedUploadedBy },
					{ key: 'annotated_at', value: selectedAnnotatedAt },
					{ key: 'annotated_by', value: selectedAnnotatedBy },
				],
				selectedContract
			),
		[
			childFilters,
			selectedInvoice,
			selectedPublishedOn,
			selectedUploadedAt,
			selectedUploadedBy,
			selectedAnnotatedAt,
			selectedAnnotatedBy,
			selectedContract,
		]
	);

	const uniqueUploadedAt = useMemo(
		() =>
			getUniqueValues(
				childFilters,
				'uploaded_at',
				[
					{ key: 'invoice_name', value: selectedInvoice },
					{ key: 'published_on', value: selectedPublishedOn },
					{ key: 'uploaded_by', value: selectedUploadedBy },
					{ key: 'annotated_at', value: selectedAnnotatedAt },
					{ key: 'annotated_by', value: selectedAnnotatedBy },
				],
				selectedContract
			),
		[
			childFilters,
			selectedInvoice,
			selectedPublishedOn,
			selectedUploadedAt,
			selectedUploadedBy,
			selectedAnnotatedAt,
			selectedAnnotatedBy,
			selectedContract,
		]
	);

	const uniqueUploadedBy = useMemo(
		() =>
			getUniqueValues(
				childFilters,
				'uploaded_by',
				[
					{ key: 'invoice_name', value: selectedInvoice },
					{ key: 'uploaded_at', value: selectedUploadedAt },
					{ key: 'published_on', value: selectedPublishedOn },
					{ key: 'annotated_at', value: selectedAnnotatedAt },
					{ key: 'annotated_by', value: selectedAnnotatedBy },
				],
				selectedContract
			),
		[
			childFilters,
			selectedInvoice,
			selectedPublishedOn,
			selectedUploadedAt,
			selectedUploadedBy,
			selectedAnnotatedAt,
			selectedAnnotatedBy,
			selectedContract,
		]
	);

	const uniqueAnnotatedAt = useMemo(
		() =>
			getUniqueValues(
				childFilters,
				'annotated_at',
				[
					{ key: 'invoice_name', value: selectedInvoice },
					{ key: 'uploaded_at', value: selectedUploadedAt },
					{ key: 'uploaded_by', value: selectedUploadedBy },
					{ key: 'published_on', value: selectedPublishedOn },
					{ key: 'annotated_by', value: selectedAnnotatedBy },
				],
				selectedContract
			),
		[
			childFilters,
			selectedInvoice,
			selectedPublishedOn,
			selectedUploadedAt,
			selectedUploadedBy,
			selectedAnnotatedAt,
			selectedAnnotatedBy,
			selectedContract,
		]
	);

	const uniqueAnnotatedBy = useMemo(
		() =>
			getUniqueValues(
				childFilters,
				'annotated_by',
				[
					{ key: 'invoice_name', value: selectedInvoice },
					{ key: 'uploaded_at', value: selectedUploadedAt },
					{ key: 'uploaded_by', value: selectedUploadedBy },
					{ key: 'annotated_at', value: selectedAnnotatedAt },
					{ key: 'published_on', value: selectedPublishedOn },
				],
				selectedContract
			),
		[
			childFilters,
			selectedInvoice,
			selectedPublishedOn,
			selectedUploadedAt,
			selectedUploadedBy,
			selectedAnnotatedAt,
			selectedAnnotatedBy,
			selectedContract,
		]
	);

	useEffect(() => {
		if (selectedCategory && selectedClient && selectedVendor) {
			const bd = {
				client_id: selectedClient.client_id,
				vendor_id: selectedVendor.vendor_id,
				category_id: selectedCategory.category_id,
			};
			setChildFilters([]);
			setContractFilters([]);
			getChildFiltersHook.mutate(bd);
			getContractFiltersHook.mutate(bd);
			fieldsFilterHook.mutate(bd);
		}
	}, [selectedCategory, selectedClient, selectedVendor]);

	useEffect(() => {
		if (getChildFiltersHook.isSuccess && getChildFiltersHook.data) {
			setChildFilters(getChildFiltersHook.data?.data);
		}
	}, [getChildFiltersHook.isSuccess, getChildFiltersHook.data]);

	useEffect(() => {
		if (getContractFiltersHook.isSuccess && getContractFiltersHook.data) {
			setContractFilters(sortDropdownOptions(getContractFiltersHook.data?.data, (o) => {
				if (typeof o === 'string') {
					return o;
				}
				return o.fname;
			}));
		}
	}, [getContractFiltersHook.isSuccess, getContractFiltersHook.data]);

	async function applySearch(page = 1) {
		if (selectedCategory && selectedClient && selectedVendor) {
			
		

		let body = {
			invoice_limit: pageSize,
			invoice_page: page,
			client_id: selectedClient?.client_id,
			vendor_id: selectedVendor?.vendor_id,
			category_id: selectedCategory?.category_id,
			fields: selectedField,
			invoice_name: selectedInvoice?.invoice_name || null,
			uploaded_by: selectedUploadedBy?._id || null,
			annotated_by: selectedAnnotatedBy?._id || null,
		};
		if (selectedPublishedOn.size > 0) {
			body.published_on = [...selectedPublishedOn].map((date) =>
				dayjs(date).format('MM-DD-YYYY')
			);
		}
		if (selectedUploadedAt.size > 0) {
			body['uploaded_at'] = [...selectedUploadedAt].map((date) =>
				dayjs(date).format('MM-DD-YYYY')
			);
		}
		if (selectedAnnotatedAt.size > 0) {
			body['annotated_at'] = [...selectedAnnotatedAt].map((date) =>
				dayjs(date).format('MM-DD-YYYY')
			);
		}
		setInvData([]);
		searchInvoiceListHook.mutate(body);
		}
	}

	useEffect(() => {
		if (searchInvoiceListHook.isSuccess && searchInvoiceListHook.data) {
			setInvData(searchInvoiceListHook.data?.data);
			setCount(searchInvoiceListHook.data?.count);
		}
	}, [searchInvoiceListHook.isSuccess, searchInvoiceListHook.data]);

	const isFirstRender = useRef(true);

	useEffect(() => {
		if (isFirstRender.current) {
			isFirstRender.current = false;
			return; // Skip applySearch on first render
		}
		if (selectedCategory && selectedClient && selectedVendor) {
			applySearch(page);
		}
	}, [page]);

	useEffect(() => {
		filterChangeDetected.current = true;
	}, [
		selectedClient,
		selectedVendor,
		selectedCategory,
		selectedContract,
		selectedField,
		selectedInvoice,
		selectedPublishedOn,
		selectedUploadedAt,
		selectedUploadedBy,
		selectedAnnotatedAt,
		selectedAnnotatedBy,
	]);

	function handleNavigate(obj) {
		const params = createSearchParams({
			client_id: obj?.client_id,
			client_name: obj?.client,
			client_list_page_no: 1,
			client_list_sort_key: '',
			client_list_sort_order: '',

			vendor_id: obj?.vendor_id,
			vendor_name: obj?.vendor,
			vendor_list_page_no: 1,
			vendor_list_sort_key: '',
			vendor_list_sort_order: '',
			category_name: obj?.category_name,
			category_id: obj?.category_id,

			invoice_id: obj._id,
			invoice_name: obj.fname,
			invoice_list_page_no: 1,
			invoice_list_sort_key: '',
			invoice_list_sort_order: '',
		}).toString();

		window.open(`/my-annotations?${params}`, '_blank'); //
	}

	useEffect(() => {
		// Define an async function inside useEffect
		const fetchPageSize = async () => {
			try {
				const page_size = await getpageSizeCall();
				console.log(page_size, 'pg in client');
				setPageSize(page_size); // Set the page size state
			} catch (error) {
				console.error('Error fetching page size:', error);
			}
		};

		fetchPageSize(); // Call the async function
	}, []); //

	const handlePageSizeChange = async (event) => {
		const selectedPageSize = event.target.value;
		setPageSize(null);
		let ret = await setpageSizeCall(selectedPageSize);
		try {
			const page_size = await getpageSizeCall();
			console.log(page_size, 'pg in client');
			setPageSize(page_size); // Set the page size state
		} catch (error) {
			console.error('Error fetching page size:', error);
		}
	};

	return (
		<div className="border pt-5 px-4 pb-0 rounded-lg mt-8 relative">
			<label className="absolute -top-6 left-4 font-black text-primary text-lg px-1 py-2 bg-white">
				Invoices
			</label>
			<div className=" p-6">
				<div className="flex w-full gap-4 items-center">
					{/* Search Bar */}
					<div className="grow relative flex items-center gap-4">
						<div className="w-full sm:w-[48%] lg:w-[23.5%]">
							<Autocomplete
								id="client"
								options={uniqueClients}
								getOptionLabel={(option) =>
									typeof option === 'string' ? option : option.client
								}
								isOptionEqualToValue={(option, value) =>
									option.client_id === value.client_id
								}
								value={selectedClient}
								onChange={(event, newValue) => {
									setSelectedClient(newValue);
								}}
								loading={getfilterHook.isFetching}
								loadingText="Loading..."
								renderInput={(params) => (
									<TextField {...params} label="Clients" fullWidth />
								)}
								renderOption={(props, option) => (
									<li {...props} key={option['client_id']}>
										{option['client']}
									</li>
								)}
							/>
						</div>

						<div className="w-full sm:w-[48%] lg:w-[23.5%]">
							<Autocomplete
								id="vendor"
								options={uniqueVendors}
								getOptionLabel={(option) =>
									typeof option === 'string' ? option : option.vendor
								}
								isOptionEqualToValue={(option, value) =>
									option.vendor_id === value.vendor_id
								}
								value={selectedVendor}
								onChange={(event, newValue) => {
									setSelectedVendor(newValue);
								}}
								loading={getfilterHook.isFetching}
								loadingText="Loading..."
								renderInput={(params) => (
									<TextField {...params} label="Vendors" fullWidth />
								)}
								renderOption={(props, option) => (
									<li {...props} key={option['vendor_id']}>
										{option['vendor']}
									</li>
								)}
							/>
						</div>

						<div className="w-full sm:w-[48%] lg:w-[23.5%]">
							<Autocomplete
								id="category"
								options={uniqueCategories}
								getOptionLabel={(option) =>
									typeof option === 'string' ? option : option.category_name
								}
								isOptionEqualToValue={(option, value) =>
									option.category_id === value.category_id
								}
								value={selectedCategory}
								onChange={(event, newValue) => {
									setSelectedCategory(newValue);
								}}
								loading={getfilterHook.isFetching}
								loadingText="Loading..."
								renderInput={(params) => (
									<TextField {...params} label="Categories" fullWidth />
								)}
								renderOption={(props, option) => (
									<li {...props} key={option['category_id']}>
										{option['category_name']}
									</li>
								)}
							/>
						</div>

						{selectedCategory && selectedClient && selectedVendor && (
							<>
								<div className="flex justify-end gap-4">
									<button
										className="bg-blue-500 text-white px-4 py-2 rounded-md disabled:bg-gray-300 disabled:cursor-not-allowed"
										onClick={() => {
											clearAllFilters();
										}}
									>
										Clear All
									</button>

									<button
										className="bg-blue-500 text-white px-4 py-2 rounded-md disabled:bg-gray-300 disabled:cursor-not-allowed"
										disabled={searchInvoiceListHook.isPending}
										onClick={() => {
											if (filterChangeDetected.current === true) {
												if (page === 1) {
													applySearch(1);
												} else {
													setpage(1);
												}
											} else {
												applySearch(page);
											}
											filterChangeDetected.current = false;
										}}
									>
										Apply Filters
									</button>
								</div>
							</>
						)}
					</div>
				</div>
			</div>

			{selectedCategory && selectedClient && selectedVendor && (
				<div className="border-t p-6 text-xs gListFilters">
					<div className="flex w-full gap-4 items-center">
						{/* Search Bar */}
						<div className="grow relative flex items-center gap-4">
							<div className="w-full sm:w-[48%] lg:w-[23.5%]">
								<Autocomplete
									id="contract"
									options={contractFilters}
									getOptionLabel={(option) =>
										typeof option === 'string' ? option : option.fname
									}
									isOptionEqualToValue={(option, value) =>
										option._id === value._id
									}
									value={selectedContract}
									onChange={(event, newValue) => {
										setSelectedContract(newValue);
									}}
									loading={getContractFiltersHook.isPending}
									loadingText="Loading..."
									renderInput={(params) => (
										<TextField {...params} label="Contracts" fullWidth />
									)}
									renderOption={(props, option) => (
										<li {...props} key={option['_id']}>
											{
												<ContractDropdownOption
													contract={option}
													client={selectedClient}
													vendor={selectedVendor}
													category={selectedCategory}
												/>
											}
										</li>
									)}
								/>
							</div>

							<div className="w-full sm:w-[48%] lg:w-[23.5%]">
								<Autocomplete
									id="fields"
									options={fields}
									getOptionLabel={(option) => option}
									isOptionEqualToValue={(option, value) => option === value}
									value={selectedField}
									onChange={(event, newValue) => {
										setSelectedField(newValue);
									}}
									loading={fieldsFilterHook.isPending}
									loadingText="Loading..."
									renderInput={(params) => (
										<TextField {...params} label="Fields" fullWidth />
									)}
									renderOption={(props, option) => (
										<li {...props} key={option}>
											{option}
										</li>
									)}
								/>
							</div>

							<div className="w-full sm:w-[48%] lg:w-[23.5%]">
								<Autocomplete
									id="invoice_name"
									options={uniqueInvoices}
									getOptionLabel={(option) => option.invoice_name}
									isOptionEqualToValue={(option, value) =>
										option._id === value._id
									}
									value={selectedInvoice}
									onChange={(event, newValue) => setSelectedInvoice(newValue)}
									loading={getChildFiltersHook.isPending}
									loadingText="Loading..."
									renderInput={(params) => (
										<TextField {...params} label="Invoices" fullWidth />
									)}
									renderOption={(props, option) => (
										<li {...props} key={option._id}>
											{option.invoice_name}
										</li>
									)}
								/>
							</div>

							<div className="w-full sm:w-[48%] lg:w-[23.5%]">
								<DatePickerButton
									dates={uniquePublishedOn}
									selectedDates={selectedPublishedOn}
									setSelectedDates={setSelectedPublishedOn}
									name={'Published Date'}
								/>

								{/* <Autocomplete
									id="published_on"
									options={uniquePublishedOn}
									getOptionLabel={(option) => dayjs(option).format("MM/DD/YYYY")}
									isOptionEqualToValue={(option, value) => option === value}
									value={selectedPublishedOn}
									onChange={(event, newValue) =>
										setSelectedPublishedOn(newValue)
									}
									loading={getChildFiltersHook.isPending}
									loadingText="Loading..."
									renderInput={(params) => (
										<TextField {...params} label="Published On" fullWidth />
									)}
									renderOption={(props, option) => (
										<li key={option} {...props}>
											{<TimeZoneConverter utcTimestamp={option} />}
										</li>
									)}
								/> */}
							</div>

							<div className="w-full sm:w-[48%] lg:w-[23.5%]">
								<DatePickerButton
									dates={uniqueUploadedAt}
									selectedDates={selectedUploadedAt}
									setSelectedDates={setSelectedUploadedAt}
									name={'Uploaded Date'}
								/>

								{/* <Autocomplete
									id="uploaded_at"
									options={uniqueUploadedAt}
									getOptionLabel={(option) => dayjs(option).format("MM/DD/YYYY")}
									isOptionEqualToValue={(option, value) => option === value}
									value={selectedUploadedAt}
									onChange={(event, newValue) =>
										setSelectedUploadedAt(newValue)
									}
									loading={getChildFiltersHook.isPending}
									loadingText="Loading..."
									renderInput={(params) => (
										<TextField {...params} label="Uploaded At" fullWidth />
									)}
									renderOption={(props, option) => (
										<li key={option} {...props}>
											{<TimeZoneConverter utcTimestamp={option} />}
										</li>
									)}
								/> */}
							</div>

							<div className="w-full sm:w-[48%] lg:w-[23.5%]">
								<Autocomplete
									id="uploaded_by"
									options={uniqueUploadedBy}
									getOptionLabel={(option) => option['uploaded_by']}
									isOptionEqualToValue={(option, value) =>
										option._id === value._id
									}
									value={selectedUploadedBy}
									onChange={(event, newValue) =>
										setSelectedUploadedBy(newValue)
									}
									loading={getChildFiltersHook.isPending}
									loadingText="Loading..."
									renderInput={(params) => (
										<TextField {...params} label="Uploaded By" fullWidth />
									)}
									renderOption={(props, option) => (
										<li {...props} key={option._id}>
											{option['uploaded_by']}
										</li>
									)}
								/>
							</div>

							<div className="w-full sm:w-[48%] lg:w-[23.5%]">
								<DatePickerButton
									dates={uniqueAnnotatedAt}
									selectedDates={selectedAnnotatedAt}
									setSelectedDates={setSelectedAnnotatedAt}
									name={'Annotation Date'}
								/>
							</div>

							<div className="w-full sm:w-[48%] lg:w-[23.5%]">
								<Autocomplete
									id="annotated_by"
									options={uniqueAnnotatedBy}
									getOptionLabel={(option) => option['annotated_by']}
									isOptionEqualToValue={(option, value) =>
										option._id === value._id
									}
									value={selectedAnnotatedBy}
									onChange={(event, newValue) =>
										setSelectedAnnotatedBy(newValue)
									}
									loading={getChildFiltersHook.isPending}
									loadingText="Loading..."
									renderInput={(params) => (
										<TextField {...params} label="Annotated By" fullWidth />
									)}
									renderOption={(props, option) => (
										<li {...props} key={option._id}>
											{option['annotated_by']}
										</li>
									)}
								/>
							</div>
						</div>
					</div>
				</div>
			)}

			<div className="listDHeight larger overflow-auto">
				{/* Table body head */}
				{invData?.length > 0 && (
					<div className="flex gap-2 mb-2">
						<div className="grow px-5 py-1 text-xs flex items-center justify-between">
							<div className="flex-none w-[140px] pr-4">
								<label
									className={`font-black block w-[140px] relative cursor-pointer`}
								>
									Name of Document
								</label>
							</div>
							<div className="flex-none px-4 text-center w-[140px]">
								<label className={`font-black block relative cursor-pointer`}>
									Client
								</label>
							</div>
							<div className="flex-none px-4 text-center w-[140px]">
								<label className={`font-black block relative cursor-pointer`}>
									Category
								</label>
							</div>
							<div className="flex-none px-4 text-center w-[155px]">
								<label className={`font-black block relative cursor-pointer`}>
									Project Type
								</label>
							</div>
							<div className="flex-none px-4 text-center w-[155px]">
								<label className={`font-black block relative cursor-pointer`}>
									Vendor
								</label>
							</div>
							<div className="flex-none px-4 text-center w-[155px]">
								<label className={`font-black block relative cursor-pointer`}>
									Uploaded By
								</label>
							</div>
							<div className="flex-none px-4 text-center w-[140px]">
								<label className={`font-black block relative cursor-pointer`}>
									Published Date
								</label>
							</div>
							<div className="flex-none px-4 text-center w-[140px]">
								<label className={`font-black block relative cursor-pointer`}>
									Uploaded Date
								</label>
							</div>
							<div className="flex-none px-4 text-center w-[140px]">
								<label className={`font-black block relative cursor-pointer`}>
									Updated Date
								</label>
							</div>
						</div>
						<div className="opacity-0 flex-none px-4 text-xs text-center w-[106px]">
								&nbsp;
						</div>
					</div>
				)}
				{/* Table body Row */}
				{!searchInvoiceListHook.isPending &&
					!inv_data_hook.isPending &&
					invData?.length == 0 && (
						<div class="flex items-center justify-center h-12">
							<p class="text-gray-500 text-lg font-medium">No data found</p>
						</div>
					)}
				{/* {['', null].includes(searchParams.get('keyword')) && (
					<div class="flex items-center justify-center h-12">
						<p class="text-gray-500 text-lg font-medium">No text searched</p>
					</div>
				)} */}
				{searchInvoiceListHook.isPending || inv_data_hook.isPending ? (
					<LoaderFull />
				) : (
					invData?.map((obj, index) => {
						return (
							<div className="flex gap-2 mb-2 tblLoop">
								<div className="grow border rounded-md px-5 py-3 text-sm flex items-center justify-between">
									<div className="flex-none w-[140px] relative flex border-r pr-4 items-center">
										<span
											title={obj?.fname}
											className="absolute w-full block truncate"
										>
											{obj?.fname ? (
												<TextHighlighter
													text={obj.fname}
													searchString={searchParams.get('keyword')}
												/>
											) : (
												<span className="text-gray-500">-</span>
											)}
										</span>
									</div>
									<div className="flex-none flex items-center border-r pr-4 text-center w-[140px] relative">
										<span
											title={obj?.client}
											className="absolute w-full block truncate"
										>
											{obj?.client ? (
												<TextHighlighter
													text={obj.client}
													searchString={searchParams.get('keyword')}
												/>
											) : (
												<span className="text-gray-500">-</span>
											)}
										</span>
									</div>
									<div className="flex-none flex items-center border-r pr-4 text-center w-[140px] relative">
										<span
											title={obj?.category_name}
											className="absolute w-full block truncate"
										>
											{obj?.category_name ? (
												<TextHighlighter
													text={obj.category_name}
													searchString={searchParams.get('keyword')}
												/>
											) : (
												<span className="text-gray-500">-</span>
											)}
										</span>
									</div>
									<div className="flex-none flex items-center pr-4 text-center w-[155px] relative">
										<span
											title={obj?.project_type}
											className="absolute w-full block truncate"
										>
											{obj?.project_type ? (
												<TextHighlighter
													text={obj.project_type}
													searchString={searchParams.get('keyword')}
												/>
											) : (
												<span className="text-gray-500">-</span>
											)}
										</span>
									</div>
									<div className="flex-none flex items-center pr-4 text-center w-[155px] relative">
										<span
											title={obj?.vendor}
											className="absolute w-full block truncate"
										>
											{obj?.vendor ? (
												<TextHighlighter
													text={obj.vendor}
													searchString={searchParams.get('keyword')}
												/>
											) : (
												<span className="text-gray-500">-</span>
											)}
										</span>
									</div>
									<div className="flex-none flex items-center pr-4 text-center w-[155px] relative">
										<span
											title={obj?.uploaded_by}
											className="absolute w-full block truncate"
										>
											{obj?.uploaded_by || (
												<span className="text-gray-500">-</span>
											)}
										</span>
									</div>
									<div className="flex-none border-r px-4 text-center w-[140px]">
										<TimeZoneConverter utcTimestamp={obj.published_on} />
									</div>
									<div className="flex-none border-r px-4 text-center w-[140px]">
										<TimeZoneConverter utcTimestamp={obj.uploaded_at} />
									</div>
									<div className="flex-none px-4 text-center w-[140px]">
										<TimeZoneConverter utcTimestamp={obj.updated_at} />
									</div>
								</div>
								<div className="flex-none flex w-[106px] pr-2">
									<button
										disabled={obj?.percentage_complete < 100}
										onClick={() => handleNavigate(obj)}
										type="button"
										title={
											obj?.percentage_complete < 100 ? 'Processing Invoice' : ''
										}
										className="vLBG block px-0 py-3 w-full text-center text-primary text-sm rounded-md font-black mx-1 disabled:bg-gray-200 disabled:text-gray-500"
									>
										{obj?.csv_upload ? 'View CSV' : 'View'}
									</button>
								</div>
							</div>
						);
					})
				)}
			</div>
			<div className="flex justify-center py-2">
				{invData && (
					<>
						<div className="flex items-center justify-between space-x-4">
							{/* Pagination Component */}
							<div className="flex items-center space-x-2">
								{/* <p>Rows per page</p> */}
								{pageSize ? (
									<FormControl
											variant="outlined"
											size="small"
											sx={{
												minWidth: 120,
												'& .MuiOutlinedInput-root': {
												borderRadius: '0.375rem', // rounded-md
												backgroundColor: 'white',
												fontSize: '0.875rem', // text-sm
												},
												'& .MuiOutlinedInput-notchedOutline': {
												borderColor: '#D1D5DB', // border-gray-300
												},
												'&:hover .MuiOutlinedInput-notchedOutline': {
												borderColor: '#60A5FA', // blue-400 on hover
												},
												'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
												borderColor: '#3B82F6', // focus:ring-blue-500
												borderWidth: '2px',
												},
											}}
											>
											<InputLabel id="page-size-label">Page Size</InputLabel>
											<Select
												labelId="page-size-label"
												value={pageSize || ''}
												onChange={handlePageSizeChange}
												label="Page Size"
											>
												{PAGE_SIZE_OPTIONS.map((size) => (
												<MenuItem key={size} value={size}>
													{size}
												</MenuItem>
												))}
											</Select>
											</FormControl>
								) : (
									<div className="w-[60px] h-[40px] flex justify-center items-center bg-gray-100 rounded-md text-sm text-center border border-gray-300">
										<span className="material-icons text-sm animate-spin">
											autorenew
										</span>{' '}
										{/* Spinner */}
									</div>
								)}
							</div>
							<Pagination
								page={page}
								onChange={(e, value) => {
									setpage(value);
								}}
								count={Math.ceil(Count / (pageSize || 20))}
								color="primary"
								variant="outlined"
								shape="rounded"
							/>
						</div>
					</>
				)}
			</div>
		</div>
	);
};
